import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const BORDER_STROKE_WIDTH = 3;
export const BORDER_STROKE_RADIUS = 10;

interface MaskProps {
    $outlineOffset: number;
    $dashed?: boolean;
    $borderStrokeWidth: number;
    $borderStrokeRadius: number;
}

export const OutlineMask = styled(motion.div)<MaskProps>`
    position: absolute;
    top: ${({ $outlineOffset }) => -$outlineOffset}px;
    right: ${({ $outlineOffset }) => -$outlineOffset}px;
    bottom: ${({ $outlineOffset }) => -$outlineOffset}px;
    left: ${({ $outlineOffset }) => -$outlineOffset}px;
    border-radius: ${({ $borderStrokeRadius }) => $borderStrokeRadius - 1}px;
    overflow: hidden;

    ${({ $dashed, $borderStrokeWidth, $borderStrokeRadius }) => css`
        mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='100%25' height='100%25' stroke-width='${$borderStrokeWidth}' stroke='%23fff'  x='0' y='0' rx='${$borderStrokeRadius}' fill='none' ${$dashed
            ? "stroke-dasharray='5' stroke-dashoffset='0' stroke-linecap='butt'"
            : ''} /%3E%3C/svg%3E");
    `}
`;

interface InnerProps {
    $primaryColor: string;
    $secondaryColor: string;
    $baseColor: string;
}

export const OutlineInner = styled.div<InnerProps>`
    position: absolute;
    top: -20%;
    right: -50%;
    bottom: -20%;
    left: -50%;
    pointer-events: none;
    will-change: transform;
    transition: transform ${({ theme }) => theme.transitions.speeds.fast}s linear;

    ${({ $primaryColor, $secondaryColor, $baseColor }) => css`
        background: conic-gradient(
            ${$primaryColor},
            ${$baseColor} 10%,
            ${$baseColor} 25%,
            ${$secondaryColor},
            ${$baseColor} 40%,
            ${$baseColor} 60%,
            ${$secondaryColor},
            ${$baseColor} 75%,
            ${$baseColor} 90%,
            ${$primaryColor}
        );
    `};
`;
